import createAction from "../../lib/createAction";

export const SET_ROW_EXPANDED = "SET_ROW_EXPANDED";
export const setRowExpanded = createAction(SET_ROW_EXPANDED, "basePath", "row");
